{
  "appId": "fidj-sandbox-0123fe7ed0000001",
  "oidcIssuer": "https://api.sandbox.fidj.ovh/oidc",
  "apiEndpoint": "https://api.sandbox.fidj.ovh/v3",
  "dashboardUrl": "https://sandbox.fidj.ovh",
  "title": "Fidj",
  "releaseVersion": "3.27.0",
  "localDemo": false,
  "allowAnonymous": false,
  "signin": "inline",
  "welcome": "One account. Every app. Your choices, with proof.",
  "description": "One place to review your apps, choose what you share, and manage your data.",
  "content": "",
  "highlights": [
    {
      "heading": "See every app",
      "body": "Every app you signed into, what it holds and why."
    },
    {
      "heading": "Switch off what you never wanted",
      "body": "Each change is recorded, app by app, with its history."
    },
    {
      "heading": "Leave and erase",
      "body": "Then follow the request until the app confirms."
    }
  ],
  "badges": [],
  "logo": "./fidj-logo.png",
  "favicon": "./fidj-logo.png",
  "moduleEntry": "#/my",
  "moduleVersion": "3.27.1",
  "moduleLabel": "console",
  "moduleMount": {
    "styles": [
      "/module/styles.css"
    ],
    "scripts": [
      {
        "src": "/module/runtime.js",
        "module": true
      },
      {
        "src": "/module/polyfills.js",
        "module": true
      },
      {
        "src": "/module/vendor.js",
        "module": true
      },
      {
        "src": "/module/main.js",
        "module": true
      }
    ],
    "markup": "<app-root></app-root>"
  }
}
